import { useLocation } from 'react-router-dom';
import { FeedbackDialogView } from './FeedbackDialogView';
import { useFeedbackApi } from './useFeedbackApi';

export interface FeedbackDialogProps {
  open: boolean;
  onClose: () => void;
}

/**
 * Connected feedback modal: wires the real backend submit and the current
 * location (pre-filled into the editable Page field) into the presentational
 * FeedbackDialogView. Mounted once in the persistent sidebar (modules/nav),
 * the same way the search palette is, so it's reachable from every page.
 */
export const FeedbackDialog = ({ open, onClose }: FeedbackDialogProps) => {
  const { submit } = useFeedbackApi();
  const { pathname, search, hash } = useLocation();
  const origin =
    typeof window !== 'undefined' ? window.location.origin : '';
  const defaultPageUrl = `${origin}${pathname}${search}${hash}`;

  return (
    <FeedbackDialogView
      open={open}
      onClose={onClose}
      defaultPageUrl={defaultPageUrl}
      onSubmit={submit}
    />
  );
};
